import gql from "graphql-tag";

export const ActivityFragment = gql`
  fragment ActivityFragment on Activity {
    uid
    slug_id
    user_uid
    title
    class_experience
    learning_goals
    assessment
    homework
    prerequisites
    published_at
    is_online
    age_min
    age_max
    size_min
    size_max
    duration_minutes
    duration_weeks
    weekly_meetings
    price_cents
    summary
    is_ongoing_weekly
    subject
    refundPolicy {
      name
      description
      type
    }
    details {
      photo
    }
    languageOfInstruction
    summaryForLearners
    isClub
    isAutoSchedulingEnabled
    autoSchedulingDaysNoticeMin
    autoSchedulingDaysNoticeMax
    allows_recurring_payment
    allows_late_enrollment
    has_building_content
    activity_schedule_setting_uid
    scheduleSettings {
      mininumNoticeHours
      maximumNoticeHours
    }
    bufferTimeMinutes
    teacherScheduleAvailability {
      uid
      startTime
      endTime
      isRecurring
      recurringEndTime
      isUnavailable
    }
    hasTeacherSchedule
    isFlexSchedule
    isOneTime
  }
`;
